var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.51094 8.40553V8.64318L9.67898 8.47514L12.8017 5.35241L14.0544 6.60511L8.62499 12.0345L3.19561 6.60609L4.44831 5.35339L7.57103 8.47515L7.73906 8.64313V8.40553V1.35937C7.73906 1.12441 7.8324 0.899068 7.99855 0.732923C8.16469 0.566777 8.39003 0.473438 8.625 0.473438C8.85996 0.473438 9.0853 0.566777 9.25145 0.732923C9.4176 0.899068 9.51094 1.12441 9.51094 1.35937V8.40553Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.196875
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6297 14.1562V10.3172H16.4016V14.1562C16.4016 14.6523 16.2045 15.128 15.8538 15.4788C15.503 15.8295 15.0273 16.0266 14.5312 16.0266H2.71875C2.22271 16.0266 1.74699 15.8295 1.39624 15.4788C1.04549 15.128 0.848438 14.6523 0.848438 14.1562V10.3172H2.62031V14.1562V14.2547H2.71875H14.5312H14.6297V14.1562Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.196875
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.65de72c5a640fb4fe9b0d93d4c4c0f51.svg";
export { ForwardRef as ReactComponent };